import { createOptionsFrom } from "@/lib/common/Option";

export const CollectionsSortOrderLabels = {
	Alphabetical: "Alphabetical",
	Chronological: "Chronological",
	Value: "Value",
	PercentageGain: "PercentageGain"
} as const;

export type CollectionsSortOrder = keyof typeof CollectionsSortOrderLabels;

export const CollectionsSortOrderOptions = createOptionsFrom(CollectionsSortOrderLabels);
